import React, { Fragment } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Card,
  CardBody,
  ButtonToggle,
  CardFooter,
  CardHeader,
} from 'reactstrap';
import { connect, useSelector } from 'react-redux';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import {
  GOTO_PREVIOUS_STEP,
  GOTO_SELECTED_STEP,
} from '../../../redux/actions/ActionTypes';
import STEP_ONE_BASIC_DETAILS from './STEP_ONE_BASIC_DETAILS.jsx';
import Payment from './Payment';
import Instructions from './Instructions';
// import STEP_TWO_APPLICATION_FORM from './STEP_TWO_APPLICATION_FORM';
const STEP_TWO_APPLICATION_FORM = React.lazy(() =>
  import('./STEP_TWO_APPLICATION_FORM')
);
// import PreviewDocument from './PreviewDocument';
const PreviewDocument = React.lazy(() => import('./PreviewDocument'));

function ApplicationForm(props) {
  const {
    ApplicationForm = {},
    dispatch,
    documentDetails = {},
    webFormInstruction = '',
  } = props;
  const { currentStep, step2 = {} } = ApplicationForm;
  const { applicationValues = [] } = step2;

  let form = useSelector((state) => state.InstructionReducer);
  const { formValues = [] } = form;

  //Previous Step
  const goToPreviousStep = () => {
    dispatch({
      type: GOTO_PREVIOUS_STEP,
      payload:
        currentStep == 3 && formValues.length == 0
          ? currentStep - 1
          : currentStep,
    });
  };

  //Go to Selected Tab
  const onTabClick = (tabIndex) => {
    dispatch({
      type: GOTO_SELECTED_STEP,
      payload: tabIndex,
    });
  };
  return (
    <Fragment>
     <div
      style={{
        backgroundColor: "#FFF3CD",
        border: "1px solid #FFE69C",
        color: "#664D03",
        padding: "16px",
        borderRadius: "8px",
        // marginBottom: "16px",
        fontSize: "12px",
        lineHeight: "0.9",
        marginRight: "3px",
        marginLeft: "3px",
        marginTop: "-15px",
        marginBottom: "10px"
      }}
    >
      <strong>Disclaimer:</strong> PayGov.US is not owned or operated by the U.S.
      government or any state or local government agency or utility.
      <br />
      <br />
      A Convenience Fee will apply to all payments made through this website.
      <br />
      <br />
      If you do not wish to pay a Convenience Fee, please contact your
      agency/creditor regarding alternative methods of payment.
    </div>
      <Card>
        <CardHeader>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames(
                  {
                    active: parseInt(currentStep) === 1,
                  },
                  'cursorHand'
                )}
                onClick={() => onTabClick(1)}
              >
                Cardholder Information
              </NavLink>
            </NavItem>
            {formValues?.length > 0 && (
              <NavItem>
                <NavLink
                  className={classnames(
                    {
                      active: parseInt(currentStep) === 2,
                    },
                    'cursorHand'
                  )}
                  onClick={() => onTabClick(2)}
                >
                  Instructions
                </NavLink>
              </NavItem>
            )}
            <NavItem>
              <NavLink
                className={classnames(
                  {
                    active: parseInt(currentStep) === 3,
                  },
                  'cursorHand'
                )}
                onClick={() => onTabClick(3)}
              >
                Certificate
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames(
                  {
                    active: parseInt(currentStep) === 4,
                  },
                  'cursorHand'
                )}
                onClick={() => onTabClick(4)}
              >
                Preview
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames(
                  {
                    active: parseInt(currentStep) === 5,
                  },
                  'cursorHand'
                )}
                onClick={() => onTabClick(5)}
              >
                Payment
              </NavLink>
            </NavItem>
          </Nav>
        </CardHeader>
        <CardBody>
          <TabContent activeTab={parseInt(currentStep)}>
            <TabPane tabId={1}>
              <Row>
                <Col sm="12">
                  <STEP_ONE_BASIC_DETAILS documentDetails={documentDetails} />
                </Col>
              </Row>
            </TabPane>
            {formValues && formValues?.length > 0 && (
              <TabPane tabId={2}>
                <Row>
                  <Col sm="12">
                    <Instructions />
                  </Col>
                </Row>
              </TabPane>
            )}
            <TabPane tabId={3}>
              <Row>
                <Col sm="12">
                  <STEP_TWO_APPLICATION_FORM
                    webFormInstruction={webFormInstruction}
                  />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={4}>
              <Row>
                <Col sm="12">
                  {applicationValues &&
                    applicationValues.length &&
                    applicationValues.map((record, index) => {
                      return (
                        <PreviewDocument
                          key={`preview_list_${index}`}
                          documentIndex={index}
                          record={record}
                          documentDetails={documentDetails}
                        />
                      );
                    })}
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={5}>
              <Row>
                <Col sm="12">
                {/* {parseInt(currentStep)==5&&<Payment documentDetails={documentDetails} />} */}
                <Payment documentDetails={documentDetails} />
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </CardBody>
        <CardFooter className="text-muted">
          {parseInt(currentStep) !== 1 && (
            <ButtonToggle color="secondary" onClick={goToPreviousStep}>
              {'Back'}
            </ButtonToggle>
          )}
          {parseInt(currentStep) !== 5 && (
            <ButtonToggle
              form={
                currentStep === 1
                  ? `basic-details`
                  : currentStep === 2
                  ? 'instruction'
                  : currentStep === 3
                  ? `endUserWebForm_${3}`
                  : currentStep === 4
                  ? 'preview'
                  : undefined
              }
              type="submit"
              color="primary"
              style={{ float: 'right' }}
            >
              {'Next'}
            </ButtonToggle>
          )}
        </CardFooter>
      </Card>
    </Fragment>
  );
}
const getState = ({ ApplicationForm }) => {
  return {
    ApplicationForm,
  };
};
const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      //
    },
    dispatch
  ),
  dispatch,
});

export default connect(getState, mapDispatchToProps)(ApplicationForm);
